export default __webpack_public_path__ + "static/media/error404.aeaf6f7c.svg";